import { useState, useRef } from "react";
import { useClickOutsideModalListener } from "src/hooks/useClickOutsideModalListener";
import { ButtonDropdownAnchor } from "./FilterControls.styles";
import {
  FilterIcon,
  LabelIcon,
  ZapIcon,
  Calendar03Icon,
  UserAccountIcon,
} from "src/assets/icons";
import { Dropdown, DropdownRowButton } from "./Dropdown";
import StatusSelector from "../dropdowns/StatusSelector";
import { SelectionIndicator } from "./FilterSelector.styles";
import { useTableFilterContext } from "src/context";
import { dateRangefromDatePeriod } from "src/utils";
import { SecondaryButton, GhostButton } from "src/components/Buttons";

export default () => {
  const {
    table,
    selectedStatuses,
    setSelectedStatuses,
    lastUpdated,
    setLastUpdated,
    applicationDate,
    setApplicationDate,
    role,
    setRole,
  } = useTableFilterContext();
  const [filterFieldMenu, setFilterFieldMenu] = useState<string | null>(null);
  const [showFilterDropdown, setShowFilterDropdown] = useState(false);
  const filterDropdownRef = useRef(null);
  useClickOutsideModalListener(filterDropdownRef, () => {
    setShowFilterDropdown(false);
    setFilterFieldMenu(null);
  });
  let filterButtonLabel;
  if (filterFieldMenu === "status") {
    filterButtonLabel = (
      <>
        <LabelIcon />
        Status
      </>
    );
  } else if (filterFieldMenu === "last_updated") {
    filterButtonLabel = (
      <>
        <ZapIcon />
        Last updated
      </>
    );
  } else if (filterFieldMenu === "application_date") {
    filterButtonLabel = (
      <>
        <Calendar03Icon />
        Application date
      </>
    );
  } else if (filterFieldMenu === "role") {
    filterButtonLabel = (
      <>
        <UserAccountIcon />
        Permissions
      </>
    );
  } else {
    filterButtonLabel = (
      <>
        <FilterIcon />
        Add filter
      </>
    );
  }
  const isDisabledForApplication = !!(
    table === "applications" &&
    selectedStatuses &&
    selectedStatuses.length > 0 &&
    lastUpdated &&
    lastUpdated.start &&
    lastUpdated.end &&
    applicationDate &&
    applicationDate.start &&
    applicationDate.end
  );
  const isDisabledForEmployees = !!(table === "employees" && role);
  const TopLevelButton = filterFieldMenu ? SecondaryButton : GhostButton;
  return (
    <ButtonDropdownAnchor ref={filterDropdownRef}>
      <TopLevelButton
        onClick={() => {
          if (!showFilterDropdown && setFilterFieldMenu) {
            // If we are on the nested menu, and want to pop back to the
            // main menu
            setFilterFieldMenu(null);
          }
          setShowFilterDropdown(!showFilterDropdown);
        }}
        disabled={isDisabledForApplication || isDisabledForEmployees}
      >
        {filterButtonLabel}
      </TopLevelButton>
      <Dropdown clickHandleRef={null} show={showFilterDropdown}>
        {table === "applications" && (
          <>
            <DropdownRowButton
              key="status-button"
              onClick={() => {
                setFilterFieldMenu("status");
                setShowFilterDropdown(false);
              }}
            >
              <LabelIcon />
              Status
            </DropdownRowButton>
            <DropdownRowButton
              key="last-updated-button"
              onClick={() => {
                setFilterFieldMenu("last_updated");
                setShowFilterDropdown(false);
              }}
            >
              <ZapIcon />
              Last updated
            </DropdownRowButton>
            <DropdownRowButton
              key="application-date-button"
              onClick={() => {
                setFilterFieldMenu("application_date");
                setShowFilterDropdown(false);
              }}
            >
              <Calendar03Icon />
              Application date
            </DropdownRowButton>
          </>
        )}
        {table === "employees" && (
          <DropdownRowButton
            key="role-button"
            onClick={() => {
              setFilterFieldMenu("role");
              setShowFilterDropdown(false);
            }}
          >
            <UserAccountIcon />
            Permissions
          </DropdownRowButton>
        )}
      </Dropdown>
      <StatusSelector
        showMenu={filterFieldMenu === "status"}
        selectedStatuses={selectedStatuses || []}
        setSelectedStatuses={(statuses) => {
          setSelectedStatuses(statuses);
          setFilterFieldMenu(null);
        }}
      />
      <Dropdown clickHandleRef={null} show={filterFieldMenu === "last_updated"}>
        {["Today", "Yesterday", "This week", "This month", "Last month"].map(
          (str) => (
            <DropdownRowButton
              key={str}
              onClick={() => {
                setLastUpdated(dateRangefromDatePeriod(str));
                setFilterFieldMenu(null);
              }}
            >
              <SelectionIndicator isSelected={false} />
              {str}
            </DropdownRowButton>
          ),
        )}
      </Dropdown>
      <Dropdown
        clickHandleRef={null}
        show={filterFieldMenu === "application_date"}
      >
        {["Today", "Yesterday", "This week", "This month", "Last month"].map(
          (str) => (
            <DropdownRowButton
              key={str}
              onClick={() => {
                setApplicationDate(dateRangefromDatePeriod(str));
                setFilterFieldMenu(null);
              }}
            >
              <SelectionIndicator isSelected={false} />
              {str}
            </DropdownRowButton>
          ),
        )}
      </Dropdown>
      <Dropdown clickHandleRef={null} show={filterFieldMenu === "role"}>
        {["GENERAL_MANAGER", "SALES_REPRESENTATIVE"].map((str) => (
          <DropdownRowButton
            key={str}
            onClick={() => {
              setRole(str);
              setFilterFieldMenu(null);
            }}
          >
            <SelectionIndicator isSelected={false} />
            {str.replace("_", " ").toLowerCase()}
          </DropdownRowButton>
        ))}
      </Dropdown>
    </ButtonDropdownAnchor>
  );
};
